import { Badge } from '@/components/ui/badge';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { getPosDescriptionConfig, sanitizePosDescriptionFields } from '@/lib/productPosDescription';

export const CatalogPosRuleEditor = ({
  categoryPrefix,
  enabled,
  fields,
  onChange,
  testIdPrefix,
}) => {
  const config = getPosDescriptionConfig(categoryPrefix);
  const selectedFields = sanitizePosDescriptionFields(categoryPrefix, fields || []);

  if (!config) {
    return (
      <div className="rounded-2xl border border-dashed border-slate-200 bg-slate-50/70 p-4 text-sm text-muted-foreground" data-testid={`${testIdPrefix}-pos-rule-unavailable`}>
        Esta categoria ainda não tem um conjunto técnico compatível para descrição POS.
      </div>
    );
  }

  return (
    <div className="space-y-4 rounded-2xl border border-slate-200 bg-slate-50/70 p-4" data-testid={`${testIdPrefix}-pos-rule-editor`}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <Label className="text-sm font-semibold">Regra de descrição POS</Label>
          <p className="mt-1 text-xs text-muted-foreground">Escolha se esta categoria/subcategoria deve ou não gerar descrição técnica automática no POS.</p>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant={enabled ? 'default' : 'outline'} data-testid={`${testIdPrefix}-pos-rule-badge`}>
            {enabled ? 'Activa' : 'Desligada'}
          </Badge>
          <Switch
            checked={Boolean(enabled)}
            onCheckedChange={(checked) => onChange({
              pos_description_enabled: checked,
              pos_description_fields: checked
                ? (selectedFields.length > 0 ? selectedFields : config.defaultFields)
                : [],
            })}
            data-testid={`${testIdPrefix}-pos-rule-switch`}
          />
        </div>
      </div>

      {enabled && (
        <div className="grid gap-2 md:grid-cols-2" data-testid={`${testIdPrefix}-pos-rule-fields-grid`}>
          {config.fields.map((field) => {
            const checked = selectedFields.includes(field.key);
            return (
              <label key={`${testIdPrefix}-${field.key}`} className="flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm">
                <Checkbox
                  checked={checked}
                  onCheckedChange={(next) => {
                    const nextFields = next
                      ? [...selectedFields, field.key]
                      : selectedFields.filter((item) => item !== field.key);
                    onChange({
                      pos_description_enabled: true,
                      pos_description_fields: nextFields,
                    });
                  }}
                />
                <span>{field.label}</span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};
